import { render, staticRenderFns } from "./cardTrialDetail.vue?vue&type=template&id=8d5fa476&scoped=true"
import script from "./cardTrialDetail.vue?vue&type=script&lang=js"
export * from "./cardTrialDetail.vue?vue&type=script&lang=js"
import style0 from "./cardTrialDetail.vue?vue&type=style&index=0&id=8d5fa476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5fa476",
  null
  
)

export default component.exports